import Link from "next/link";
import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary";
type Size = "sm" | "md";

const BASE = "inline-flex items-center justify-center rounded-full font-bold";
const VARIANT: Record<Variant, string> = {
  primary: "bg-ink text-paper-2 transition-transform hover:-translate-y-0.5",
  secondary: "border border-line bg-paper-2 text-ink transition-colors hover:border-gold",
};
const SIZE: Record<Size, string> = { md: "px-6 py-3.5 text-base", sm: "px-4 py-2 text-sm" };

type CommonProps = { variant?: Variant; size?: Size; className?: string; children: ReactNode };
type LinkProps = CommonProps & { href: string };
type BtnProps = CommonProps & { href?: undefined } & Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    "className" | "children"
  >;
type Props = LinkProps | BtnProps;

export function Button(props: Props) {
  const { variant = "primary", size = "md", className = "", children } = props;
  const cls = `${BASE} ${VARIANT[variant]} ${SIZE[size]} ${className}`.trim();
  if ("href" in props && props.href) {
    return (
      <Link href={props.href} className={cls}>
        {children}
      </Link>
    );
  }
  // Destructure out shared + link-only props; forward the rest to <button>.
  const {
    variant: _v,
    size: _s,
    className: _c,
    children: _ch,
    href: _h,
    ...rest
  } = props as BtnProps;
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
